import { isTestCompany } from "../utils/auth";
import http from "../utils/http";
import { toast } from "../utils/toast";

export const getNotifications = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/push-notifications/list", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const readNotifications = (messageId, isRead = true) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      resolve();
      return;
    }
    http
      .put("/push-notifications/set/read", {
        isRead,
        messageId
      })
      .then((res) => {
        toast.success(`${messageId.length}개 알림이 읽음처리 되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getUnreadNotifications = () => {
  return new Promise((resolve, reject) => {
    http
      .post("/push-notifications/list/count", {
        "search": {
          "isRead": false,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPushNotiStates = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/push-notifications/settings/list`, { search: { employeeIdxs: [idx] } })
      .then((res) => {
        resolve(res.data?.settings || []);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updatePushNotiState = (params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/push-notifications/settings`, params)
      .then((res) => {
        resolve(res.data?.settings || []);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getNotificationTypes = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/push-notifications/type/list`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getNotificationDefaultSettings = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/push-notifications/settings/list`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};